import {useNavigate} from "react-router-dom";

export const useMenstrualCycleTableItem = (recommended_type: string) => {
    const navigate = useNavigate();

    const onEdit = () => {
        navigate('/dashboard/menstrual-phases/edit/' + recommended_type);
    };

    return { onEdit };
}